import React from "react";
import { ApolloProvider } from "@apollo/client";

const wrapComponent = ({ Component, apolloClient }) => props => (
  <ApolloProvider client={apolloClient}>
    <Component {...props} />
  </ApolloProvider>
);

export default wrapComponent;
